exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2_Q6rrYCFblD3M{display:inline-block;line-height:1}._13k7NyjpNL8uY6 svg{height:14px;width:14px;line-height:14px}.z53beXNiDPJAy2 svg{height:16px;width:16px;line-height:16px}._3Dk1GPoKnJxuep svg{height:20px;width:20px;line-height:20px}._1fXLS4oRrPeaIC svg{height:24px;width:24px;line-height:24px}.Ea7tC9xTZW-DI4{box-sizing:border-box;padding:3px}.Hs-huY1cImUSej{box-sizing:border-box;padding:2px}.M2xDGmenJp4InX{box-sizing:border-box;padding:6px}._1uRZNO7JETQ6DM{box-sizing:border-box;padding:4px}", ""]);

// exports
exports.locals = {
	"nch-icon": "_2_Q6rrYCFblD3M",
	"nch-icon--xsmall": "_13k7NyjpNL8uY6",
	"nch-icon--small": "z53beXNiDPJAy2",
	"nch-icon--medium": "_3Dk1GPoKnJxuep",
	"nch-icon--large": "_1fXLS4oRrPeaIC",
	"nch-icon--xsmall-block": "Ea7tC9xTZW-DI4",
	"nch-icon--small-block": "Hs-huY1cImUSej",
	"nch-icon--medium-block": "M2xDGmenJp4InX",
	"nch-icon--large-block": "_1uRZNO7JETQ6DM"
};